import { cmsInit } from '@common/CMS/helpers/init';
import { initCookies } from '@common/Core/helpers/cookies';
import {
    trackCheckout,
    trackGaPageView,
    trackGaDetailView,
    trackGaPromotions,
    trackImpressionClick,
    trackGaCartChange,
    trackBannerImpressions,
    trackBmpProductView
} from '@common/Tracking';
import { track as trackAffiliates } from '@common/Tracking/affiliates';
import { bmpListTracker } from '@common/Tracking/BmpProductView/trackList';
import { handleSnowplowTrackerInitialisation, init } from '@common/Tracking/helpers/tracker';
import { itemsParametersTracker } from '@common/Tracking/itemsParameters';
import NavFromTracker from '@common/Tracking/NavFrom';
import { track as trackNewsletter } from '@common/Tracking/newsletter';
import RealListTracker from '@common/Tracking/RealList';
import { extendGaCookieExpirationDate } from '@helpers/analytics';
import { get as getCookie } from '@helpers/cookie';

/**
 * Initial dataLayer pushes moved from legacy public/js
 */
function handleInitialDataLayerPushes() {
    if (typeof dataLayer !== 'undefined') {
        const gaCookie = getCookie('_ga');

        if (gaCookie) {
            /* eslint-disable no-undef */
            dataLayer.push({ utma: gaCookie });
            dataLayer.push({ ga: gaCookie });
            /* eslint-enable no-undef */
        }

        // let google tag manager know when user wants to be fully authenticated
        // (elevate from ROLE_TOKEN_USER to ROLE_USER)
        if (document.body.getAttribute('data-action') === 'elevate') {
            /* eslint-disable no-undef */
            dataLayer.push({ elevateAccess: 1 });
            /* eslint-enable no-undef */
        }
    }
}

handleInitialDataLayerPushes();
initCookies();
init();
NavFromTracker.init();
RealListTracker.init();
bmpListTracker();
itemsParametersTracker();

extendGaCookieExpirationDate();

handleSnowplowTrackerInitialisation({ env: App?.Config?.env, webshop: { id: App?.Config?.theme } });

trackAffiliates();
trackCheckout();
trackGaPageView();
trackGaDetailView();
trackGaPromotions();
trackImpressionClick();
trackGaCartChange();
trackBannerImpressions();
trackNewsletter();
trackBmpProductView();

cmsInit();
